import React from 'react';
import { ICheckItem } from '../../types/Reports';
import Modal from '../custom/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useCriteria } from '../hooks/useCriteria';
import ModalClose from './ModalClose';
import CriteriaExplanationContainer from './CriteriaExplanationContainer';
import { ModalEnum, selectSelectedCheckItem, uiActions } from '../../app/slices/ui.slice';
import { useAppTranslation } from '../../i18n';

export const CheckItemInfoModal = () => {
	const selectedCheckItem = useAppSelector(selectSelectedCheckItem) as ICheckItem;
	// custom hook
	const [title, text] = useCriteria(selectedCheckItem);
	const { t } = useAppTranslation();

	const dispatch = useAppDispatch();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.CODE_INFO_MODAL));
	};

	if (!selectedCheckItem) {
		return (
			<Modal onClose={handleOnCloseModal} ariaLabel={t('a11y.information')}>
				<ModalClose onClose={handleOnCloseModal} />
				<div>
					<p role="heading" aria-level={2}>
						{t('codes.invalid-code-title')}
					</p>
					<span>{t('codes.invalid-code-text')}</span>
				</div>
			</Modal>
		);
	}

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={typeof title === 'string' ? title : t('a11y.information')}>
			<ModalClose onClose={handleOnCloseModal} />
			<CriteriaExplanationContainer title={title} content={text} />
		</Modal>
	);
};

export default CheckItemInfoModal;
